import React from 'react';
import { View } from 'react-native';

import { getRestockExpiryValues } from '../../../common/utils/serviceDocket/marketRestockCorrection';

import { Text } from '../../components';
import { Card } from '../../design/components';
import DateSelectorInput from '../../components/input/DateSelectorInput';
import InputNumber from '../../components/input/InputNumber';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { createCorrectMarketRestockStyles } from './CorrectMarketRestockView.styles';
import RestockCorrectionStat from './RestockCorrectionStat';

// One delivered product: original and current quantities, the corrected quantity and its batch expiry.
const RestockCorrectionProductCard = ({
	item,
	draft,
	fieldsDisabled,
	updateQuantity,
	updateExpiryDate,
}) => {
	const styles = useThemedStyles(createCorrectMarketRestockStyles);
	const hasBatchProvenance = item.product?.isFreshFood ||
		getRestockExpiryValues(item.planogramItemExpiryDatesAtPick).length > 0;

	return (
		<Card tone="raised" style={styles.productCard}>
			<View>
				<Text style={styles.productName}>{item.product.name}</Text>
				{item.selection && (
					<Text style={styles.hint}>Selection {item.selection}</Text>
				)}
				{item.removedProduct && (
					<Text style={styles.hint}>Replaced {item.removedProduct.name}</Text>
				)}
			</View>
			<View style={styles.quantityRow}>
				<RestockCorrectionStat label="Original" value={Number(item.originalRestockDeliveredQuantity || 0)} />
				<RestockCorrectionStat label="Current" value={Number(item.restockDeliveredQuantity || 0)} />
				<View style={styles.correctedQuantity}>
					<Text style={styles.fieldLabel}>Corrected</Text>
					<InputNumber
						value={draft?.quantity}
						onChangeInternal={value => updateQuantity(item.id, value)}
						decimalPlaces={0}
						disabled={fieldsDisabled}
						style={styles.quantityInput}
					/>
				</View>
			</View>
			{Number(item.swapQuantity || 0) > 0 && (
				<Text style={styles.hint}>
					Includes {Number(item.swapQuantity)} swapped
				</Text>
			)}
			{hasBatchProvenance && (
				<View style={styles.batchField}>
					<Text style={styles.fieldLabel}>Delivered batch expiry</Text>
					<DateSelectorInput
						value={draft?.expiryDate || ''}
						onChange={value => updateExpiryDate(item.id, value)}
						disabled={fieldsDisabled}
					/>
					<Text style={styles.hint}>Current: {draft?.batchLabel}</Text>
				</View>
			)}
		</Card>
	);
};

export default RestockCorrectionProductCard;
